<template>
    <div class="flex-row" :class="{gap, vcenter, center, wrap }">
        <slot></slot>
    </div>
</template>
<script>

export default {
    props:{
        center:{
            type:Boolean
        },
        vcenter:{
            type:Boolean,
        },
        gap:{
            type:Boolean,
        },
        wrap:{
            type:Boolean
        },
    },
}

</script>
<style scoped lang="scss">
.flex-row {
    display: flex;
    // overflow: hidden;
    min-height: 0;
    min-width: 0;
    flex: 1;
    flex-direction: row;

    &.center {
        align-items: center;
        justify-content: center;
    }

    &.vcenter {
        align-items: center;
    }

    &.wrap {
        flex-wrap: wrap;
    }

    &.gap {
        gap: 0.4em;
    }
}



</style>